<template>
  <section>
    <div class="form-control">
      <label class="label">
        <span class="label-text">Name</span>
      </label>
      <input
        type="text"
        placeholder="Name"
        class="input border-blue-600"
        :value="name"
      />
    </div>
    <div class="form-control">
      <label class="label">
        <span class="label-text">Payment Amount</span>
      </label>
      <input
        type="number"
        :value="amount"
        placeholder="Amount"
        class="input border-blue-600"
        disabled="disabled"
      />
    </div>
    <div class="form-control">
      <label class="label">
        <span class="label-text">Order Id</span>
      </label>
      <input
        type="text"
        :value="orderId"
        placeholder="Id"
        disabled="disabled"
        class="input border-blue-600"
      />
    </div>
    <div class="flex gap-4 my-5">
      <button
        @click="hide"
        class="
          flex
          items-center
          justify-center
          w-max
          px-10
          font-bold
          py-3
          text-base text-center text-white
          transition
          duration-500
          ease-in-out
          transform
          bg-red-600
          rounded-xl
          hover:bg-red-400
        "
      >
        Cancel</button
      ><button
        @click.prevent="payAmount"
        class="
          flex
          items-center
          justify-center
          w-max
          px-10
          font-bold
          py-3
          text-base text-center text-white
          transition
          duration-500
          ease-in-out
          transform
          bg-blue-700
          rounded-xl
          hover:bg-blue-600
          focus:outline-none
          focus:ring-2
          focus:ring-offset-2
          focus:ring-blue-500
        "
      >
        Pay
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "submodal",
  props: [
    "hide",
    "orderId",
    "amount",
    "name",
    "email",
    "mobileno",
    "description",
  ],
  data() {
    return {
      sucessPay: [],
      errorPay: [],
      failureData: { Status: "Failure" },
      sucessData: { Status: "Success" },
    };
  },
  methods: {
    payAmount() {
      let options = {
        key: process.env.RAZORID,
        amount: this.amount,
        currency: "INR",
        name: "SITRA",
        description: this.description,
        image: "http://sitraonline.org.in/images/sitralogo.jpg",
        order_id: this.orderId,
        callback_url:
          "http://sitraonline.org.in/onlineserviceapi/index.php/api/pg_response_page_new",
        prefill: {
          name: this.name,
          email: this.email,
          contact: this.mobileno,
        },
        notes: {
          address: "Sitra 13/37, Avinashi Road, Coimbatore Aerodrome Post",
        },
        theme: {
          color: "#3399cc",
        },
      };

      const razorPay = new window.Razorpay(options);
      razorPay.open();
    },
  },
};
</script>
